import React from "react";
import styled from "styled-components";

interface IRatingStars {
  metaprops?: boolean;
  rating: number;
  size: "big" | "small";
}

const RatingDiv = styled.div`
  display: inline-block;
  align-items: center;
  font-size: 0.85rem !important;
  padding-left: 0 !important;
  .review-stars--big {
    width: 90px;
  }
  .review-stars--small {
    width: 60px;
  }
  .review-stars--small,
  .review-stars--big {
    margin-right: 4px;
    position: relative;
    display: inline-block;
    overflow: hidden;
    &__scale {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 0;
      background-color: #1ba1e2;
      z-index: -1;
      box-sizing: border-box;
      &.count-0 {
        width: 0;
      }
      &.count-1 {
        width: 10%;
      }
      &.count-2 {
        width: 20%;
      }
      &.count-3 {
        width: 30%;
      }
      &.count-4 {
        width: 40%;
      }
      &.count-5 {
        width: 50%;
      }
      &.count-6 {
        width: 60%;
      }
      &.count-7 {
        width: 70%;
      }
      &.count-8 {
        width: 80%;
      }
      &.count-9 {
        width: 90%;
      }
      &.count-10 {
        width: 100%;
      }
    }
    &:before {
      content: "";
      padding-bottom: 20%;
      width: 100%;
      height: 100%;
      display: block;
      background-repeat: no-repeat;
      background-size: contain;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 20'%3E%3Cdefs%3E%3Cstyle%3E.b%7Bfill:%231ba1e2%7D%3C/style%3E%3C/defs%3E%3Cpath d='M0 0v20h100V0zm19.2 8.5l-4 4a.5.5 0 00-.1.4l1 5.5a.5.5 0 01-.8.6l-5-2.6a.6.6 0 00-.5 0l-5 2.6a.5.5 0 01-.8-.6L5 13a.5.5 0 00-.2-.5l-4-3.9a.5.5 0 01.3-.9l5.5-.8a.5.5 0 00.4-.3l2.5-5a.5.5 0 011 0l2.5 5a.5.5 0 00.4.3l5.6.8a.5.5 0 01.2.9zm20 0l-4 4a.5.5 0 00-.1.4l1 5.5a.5.5 0 01-.8.6l-5-2.6a.6.6 0 00-.5 0l-5 2.6a.5.5 0 01-.8-.6l1-5.5a.5.5 0 00-.2-.5l-4-3.9a.5.5 0 01.3-.9l5.6-.8a.5.5 0 00.3-.3l2.5-5a.5.5 0 011 0l2.5 5a.5.5 0 00.4.3l5.6.8a.5.5 0 01.2.9zm20 0l-4 4a.5.5 0 00-.1.4l1 5.5a.5.5 0 01-.8.6l-5-2.6a.6.6 0 00-.5 0l-5 2.6a.5.5 0 01-.8-.6l1-5.5a.5.5 0 00-.1-.5l-4-3.9a.5.5 0 01.3-.9l5.5-.8a.5.5 0 00.3-.3l2.5-5a.5.5 0 011 0l2.5 5a.5.5 0 00.4.3l5.6.8a.5.5 0 01.2.9zm20 0l-4 4a.5.5 0 00-.1.4l.9 5.5a.5.5 0 01-.8.6l-5-2.6a.6.6 0 00-.5 0l-5 2.6a.5.5 0 01-.7-.6l1-5.5a.5.5 0 00-.2-.5l-4-3.9a.5.5 0 01.3-.9l5.6-.8a.5.5 0 00.3-.3l2.5-5a.5.5 0 011 0l2.5 5a.5.5 0 00.4.3l5.6.8a.5.5 0 01.2.9zm20 0l-4 4a.5.5 0 00-.1.4l.9 5.5a.5.5 0 01-.8.6l-5-2.6a.6.6 0 00-.5 0l-5 2.6a.5.5 0 01-.7-.6l1-5.5a.5.5 0 00-.2-.5l-4-3.9a.5.5 0 01.3-.9l5.6-.8a.5.5 0 00.3-.3l2.5-5a.5.5 0 011 0l2.5 5a.5.5 0 00.4.3l5.6.8a.5.5 0 01.2.9z' fill='%23fff'/%3E%3Cpath class='b' d='M10 3.9l1.6 3.3a2 2 0 001.6 1l3.6.6-2.7 2.5a2 2 0 00-.5 1.9l.6 3.6-3.3-1.7a2 2 0 00-1.8 0l-3.3 1.7.6-3.6a2 2 0 00-.5-1.8L3.2 8.8l3.6-.5a2 2 0 001.6-1.1L10 3.9m0-2.7a.5.5 0 00-.5.3L7 6.5a.5.5 0 01-.4.3l-5.5.8a.5.5 0 00-.3.9l4 4a.5.5 0 01.2.4l-1 5.5a.5.5 0 00.5.7.6.6 0 00.3-.1l5-2.6a.6.6 0 01.5 0l5 2.6a.6.6 0 00.2 0 .5.5 0 00.6-.6L15 13a.5.5 0 01.2-.5l4-3.9a.5.5 0 00-.3-.9l-5.6-.8a.5.5 0 01-.3-.3l-2.5-5a.5.5 0 00-.5-.3zM30 3.9l1.6 3.3a2 2 0 001.5 1l3.7.6-2.7 2.5a2 2 0 00-.5 1.9l.6 3.6-3.3-1.7a2 2 0 00-1.8 0l-3.3 1.7.6-3.6a2 2 0 00-.6-1.8l-2.6-2.6 3.7-.5a2 2 0 001.5-1.1L30 3.9m0-2.7a.5.5 0 00-.5.3l-2.5 5a.5.5 0 01-.4.3l-5.6.8a.5.5 0 00-.3.9l4 4a.5.5 0 01.2.4l-.9 5.5a.5.5 0 00.5.7.6.6 0 00.3-.1l5-2.6a.6.6 0 01.5 0l5 2.6a.6.6 0 00.2 0 .5.5 0 00.5-.6L35 13a.5.5 0 01.2-.5l4-3.9a.5.5 0 00-.3-.9l-5.6-.8a.5.5 0 01-.3-.3l-2.5-5a.5.5 0 00-.5-.3zM50 3.9l1.6 3.3a2 2 0 001.5 1l3.7.6-2.7 2.5a2 2 0 00-.5 1.9l.6 3.6-3.3-1.7a2 2 0 00-1.8 0l-3.3 1.7.6-3.6a2 2 0 00-.6-1.8l-2.6-2.6 3.6-.5a2 2 0 001.6-1.1L50 3.9m0-2.7a.5.5 0 00-.5.3l-2.5 5a.5.5 0 01-.4.3l-5.6.8a.5.5 0 00-.3.9l4 4a.5.5 0 01.2.4l-1 5.5a.5.5 0 00.5.7.6.6 0 00.3-.1l5-2.6a.6.6 0 01.5 0l5 2.6a.6.6 0 00.2 0 .5.5 0 00.5-.6L55 13a.5.5 0 01.2-.5l4-3.9a.5.5 0 00-.3-.9l-5.6-.8a.5.5 0 01-.3-.3l-2.5-5a.5.5 0 00-.5-.3zM70 3.9l1.6 3.3a2 2 0 001.6 1l3.6.6-2.6 2.5a2 2 0 00-.6 1.9l.6 3.6-3.3-1.7a2 2 0 00-1.8 0l-3.3 1.7.6-3.6a2 2 0 00-.5-1.8l-2.7-2.6 3.6-.5a2 2 0 001.6-1.1L70 3.9m0-2.7a.5.5 0 00-.5.3l-2.5 5a.5.5 0 01-.4.3l-5.6.8a.5.5 0 00-.3.9l4 4a.5.5 0 01.2.4l-.9 5.5a.5.5 0 00.5.7.6.6 0 00.3-.1l5-2.6a.6.6 0 01.5 0l5 2.6a.6.6 0 00.2 0 .5.5 0 00.5-.6L75 13a.5.5 0 01.2-.5l4-3.9a.5.5 0 00-.3-.9l-5.6-.8a.5.5 0 01-.3-.3l-2.5-5a.5.5 0 00-.5-.3zM90 3.9l1.6 3.3a2 2 0 001.6 1l3.6.6-2.6 2.5a2 2 0 00-.6 1.9l.6 3.6-3.3-1.7a2 2 0 00-1.8 0l-3.3 1.7.6-3.6a2 2 0 00-.5-1.8l-2.7-2.6 3.7-.5a2 2 0 001.5-1.1L90 3.9m0-2.7a.5.5 0 00-.5.3l-2.5 5a.5.5 0 01-.4.3l-5.6.8a.5.5 0 00-.3.9l4 4a.5.5 0 01.2.4l-.9 5.5a.5.5 0 00.5.7.6.6 0 00.3-.1l5-2.6a.6.6 0 01.5 0l5 2.6a.6.6 0 00.2 0 .5.5 0 00.5-.6L95 13a.5.5 0 01.2-.5l4-3.9a.5.5 0 00-.3-.9l-5.6-.8a.5.5 0 01-.3-.3l-2.5-5a.5.5 0 00-.5-.3z'/%3E%3C/svg%3E");
    }
  }
`;

const RatingStars: React.FC<IRatingStars> = (props) => {
  const {metaprops, rating, size} = props;
  const count = Math.round(rating * 2);
  const meta = metaprops === undefined ? true : metaprops;

  return (
    <RatingDiv>
      <div className={`review-stars--${size}`}>
        {meta ? (
          <div
            className={`review-stars--${size}__scale count-${count}`}
            itemProp="reviewRating"
            itemType="http://schema.org/Rating"
          >
            <meta itemProp="ratingValue" content={rating.toString()} />
          </div>
        ) : (
          <div className={`review-stars--${size}__scale count-${count}`}>&nbsp;</div>
        )}
      </div>
    </RatingDiv>
  );
};

export default RatingStars;
